<template>
    <img :src="require('@/assets/logo-CorWfPtl.png')" alt="GallabBG Logo" class="logo" :style="{ width: size }"
        @click="goToConfigurator" />
</template>

<script>
export default {
    name: 'GallabLogo',
    props: {
        size: {
            type: String,
            default: '250px'
        }
    },
    methods: {
        goToConfigurator() {
            this.$router.push('/')
        },
    }
}
</script>

<style>
.logo {
    background-color: transparent;
    display: block;
    margin-bottom: 50px;
    cursor: pointer;
}
</style>